import EyeStrikeStrikeZone from './EyeStrikeStrikeZone';

export default EyeStrikeStrikeZone;
